

export default {
  SET_ITEMS(state, payload) {
    state.products = payload
  },

  ADD_ITEM(state, payload) {
    state.products.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.products.findIndex((p) => p.id == payload.id)
      Object.assign(state.products[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.products.findIndex((p) => p.id == itemId)
      state.products.splice(ItemIndex, 1)
  }
}
